var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.49,11.31l-4.37-4.37c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l2.65,2.65H3.31c-.55,0-1,.45-1,1s.45,1,1,1h8.07l-2.65,2.65c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l4.34-4.34c.39-.39.39-1.02,0-1.41Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_403"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.69,22.36h-8.14c-.55,0-1-.45-1-1s.45-1,1-1h7.14V3.64h-7.14c-.55,0-1-.45-1-1s.45-1,1-1h8.14c.55,0,1,.45,1,1v18.73c0,.55-.45,1-1,1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.7577df59945822298d6a9827edcb495a.svg";
export { ForwardRef as ReactComponent };